const subscription = (subscription = {}, action) => {
  switch (action.type) {
    case 'SET_SUBSCRIPTION':
      return action.payload
    default:
      return subscription
  }
}
export default subscription
